<h2 mat-dialog-title>Aziende</h2>
<div mat-dialog-content class="dialog-center-cont">
  <app-lista-aziende [id_azienda]="id_azienda" [utente]="utente"></app-lista-aziende>
</div>
<div mat-dialog-actions class="dialog-footer-cont">
  <div>
    <button mat-dialog-close mat-flat-button color="accent" class="accent-button">Chiudi</button>
  </div>
</div>
